export default __webpack_public_path__ + "static/media/13.b54cee4c.svg";